import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdDelete, MdModeEdit } from "react-icons/md"; 

export class DealsCategoryTable extends Component {
  render() {
    const columns = [
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Description",
        accessor: "description"
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteCategory,
      showModal,
      setPageNumber,
      setPageSize
    } = this.props;

    const actions = [
      {
        name: "edit",
        btnText: "Edit",
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
        tooltip: "Edit"
      },
      {
        name: "cancel",
        btnText: "Delete",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
        hiddenParam: "hasPassed",
        tooltip: "Delete"
      }
    ];

    return (
      <div>
        <Card className="pp4">
          <CardHeader>Deal Categories</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.data : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteCategory}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              hideSearchParam={true}
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default DealsCategoryTable;
